import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cart",
  initialState: [],
  reducers: {
    addToCart: (state, action) => {
      state.push(action.payload);
    },
    removeFromCart:(state,action)=>{
      return state.filter(i=>i.id!=action.payload)
    },
    clearCart:(state)=>{
      return state=[]
    }
  },
});

export default cartSlice.reducer;

export const { addToCart,removeFromCart,clearCart } = cartSlice.actions;
